import { useTranslation } from "react-i18next";

import { ProductCardFooterItem } from "@/components/Layout/BaseLayouts/ProductCard/ProductCardFooterItem";
import { DeviceProductCard } from "@/components/Portal/components/PortalDeviceTiles/TilesGrid/Tiles/DeviceProductCard/DeviceProductCard.tsx";
import { getIconForProductCategory } from "@/components/Portal/components/PortalDeviceTiles/TilesGrid/Tiles/DeviceProductCard/ProductCategoryIcon.tsx";
import { SimStatusChip } from "@/components/Portal/components/PortalDeviceTiles/TilesGrid/Tiles/DeviceProductCard/SimStatusChip.tsx";
import { ExtendedSimCardDetail } from "@/hooks/useExtendedSims.ts";
import { useGetTitle } from "@/hooks/useGetTitle.ts";
import { SimCardDetailSimStatusReason } from "@/services/model";
import { getFlatNameFromDevice } from "@/utils/deviceUtils";

interface PendingSimTileProps {
  device: ExtendedSimCardDetail;
  manageRoute: string;
}

export const PendingSimTile = ({
  device,
  manageRoute,
}: PendingSimTileProps) => {
  const { t } = useTranslation("portal");
  const title = useGetTitle(device.alias);
  const icon = getIconForProductCategory(device);
  const couldNotRenew =
    device.simStatusReason === SimCardDetailSimStatusReason.LOCK_REQUESTED;

  return (
    <DeviceProductCard
      dataTestid="pending-sim"
      icon={icon}
      title={title}
      subtitle={getFlatNameFromDevice(device)}
      navigationTarget={`${manageRoute}?simId=${device.simId}`}
      chips={
        <SimStatusChip
          status={device.simStatus}
          servicePending={device.servicePending}
          simStatusReason={device.simStatusReason}
        />
      }
      footer={
        couldNotRenew ? (
          <ProductCardFooterItem
            variant="notification"
            tone="error"
            title={t("layout.tiles.pending.couldNotRenewTitle")}
            description={t("layout.tiles.pending.missingPaymentMethod")}
          />
        ) : (
          <ProductCardFooterItem
            variant="notification"
            tone="info"
            title={t("layout.tiles.pending.inProcess")}
          />
        )
      }
    />
  );
};
